/* eslint-disable import/no-named-as-default */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
// import { useCallback, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import { Box, Card, Grid, Stack, TextField, Switch, InputLabel } from '@material-ui/core';
// utils
// routes
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import {
  createNewCampaignRule,
  updateCampaignParentRule,
  updateCampaignRule
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/campaignrules';

// ----------------------------------------------------------------------

CampaignRuleParentForm.propTypes = {
  editId: PropTypes.object,
  handleClose: PropTypes.func,
  parentRuleId: PropTypes.number
};

export default function CampaignRuleParentForm({ editId, handleClose }) {
  const dispatch = useDispatch();

  const ValidationSchema = Yup.object().shape({
    parentRuleName: Yup.mixed().required('*Required')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      parentRuleName: editId ? editId.name : '',
      status: editId ? editId.status : false
    },
    validationSchema: ValidationSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const campaignParentRuleData = {
          campaign_rule_name: values.parentRuleName
          // active: values.status
        };
        setSubmitting(false);

        if (editId) {
          dispatch(updateCampaignParentRule(campaignParentRuleData, editId?.parentRuleId));
        } else {
          dispatch(createNewCampaignRule(campaignParentRuleData, editId.parentRuleId));
        }
        handleClose();
      } catch (error) {
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, handleChange } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Card sx={{ p: 3 }}>
          <Stack spacing={2}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
              <TextField
                fullWidth
                name="parentRuleName"
                label="Campaign Rule Name"
                value={values.parentRuleName}
                onChange={handleChange}
                error={Boolean(touched.parentRuleName && errors.parentRuleName)}
                helperText={touched.parentRuleName && errors.parentRuleName}
              />
            </Stack>
            {/* 
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="flex-start">
              <InputLabel sx={{ mt: 1 }}>Status: </InputLabel>
              <Switch checked={values.status} />
            </Stack> */}
          </Stack>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Stack spacing={3}>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton sx={{ marginRight: '1rem' }} type="button" variant="outlined" onClick={handleClose}>
                    Cancel
                  </LoadingButton>
                  <LoadingButton sx={{ marginRight: '1rem' }} type="submit" variant="contained" loading={isSubmitting}>
                    {!editId ? 'Save' : 'Update Changes'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Card>
      </Form>
    </FormikProvider>
  );
}
